export default "__VITE_ASSET__4f2fb2ae__"